import { Button, Pagination, Table } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import React, { useState, useCallback, useEffect } from "react";

import { useFetch } from "../../utils/hooks/useFetch";
import { Filters } from "./components/Filters";
import { TableTitle } from "./components/TableTitle";
// import { NestedTable } from "./components/NestedTable";
import styles from "./Reports.module.css";
import moment from "moment";
import { columnTemplate } from "./utils/columnsList";
import { openWarningNotification } from "../../utils/notifications";
import { numberWithSpaces } from "../../utils/abbreviateNumber";
import { searchReportsN2sService } from "../../services/searchReportsN2s";
import { MissingDatesModal } from "../../components/MissingDatesModal";

export const SearchReportsN2S = ({ location }) => {
  const [columnsData] = useState(columnTemplate);
  const [tableColumns, setTableColumns] = useState([]);
  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(30);
  const pageSizeOptions = [10, 20, 30, 50, 100];

  const [selectedFilters, setSelectedFilters] = useState({});
  const [dateRange, setDateRange] = useState({
    from: moment().subtract(2, "days"),
    to: moment(),
  });
  const [sorting, setSorting] = useState({
    // date: "descend",
  });

  const [missingDatesVisible, setMissingDatesVisible] = useState(false);

  const sumOfDataRefactor = () => {
    if (sumOfData) {
      if (sumOfData[0]) {
        let sumOfDataRefactored = { ...sumOfData[0] };
        if (sumOfData[0].revenue) {
          sumOfDataRefactored.revenue =
            "$ " +
            Number(sumOfData[0].revenue).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
        }
        if (sumOfData[0].cr) {
          sumOfDataRefactored.cr =
            parseFloat(sumOfData[0].cr).toFixed(2) + " %";
        }
        if (sumOfData[0].rpm) {
          sumOfDataRefactored.rpm =
            "$ " +
            Number(sumOfData[0].rpm).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
        }
        if (sumOfData[0].total_searches) {
          sumOfDataRefactored.total_searches = numberWithSpaces(
            sumOfData[0].total_searches
          );
        }
        if (sumOfData[0].monetized_searches) {
          sumOfDataRefactored.monetized_searches = numberWithSpaces(
            sumOfData[0].monetized_searches
          );
        }
        if (sumOfData[0].tq) {
          sumOfDataRefactored.tq = parseFloat(sumOfData[0].tq).toFixed(2);
        }
        if (sumOfData[0].revenue) {
          sumOfDataRefactored.revenue =
            "$ " +
            Number(sumOfData[0].revenue).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
        }
        return sumOfDataRefactored;
      }
    }
  };

  const refactorTableData = () => {
    const tableDataRefactored = tableData
      ? tableData.map((el, index) => {
        const refactor = { ...el };
        refactor.revenue =
          refactor.revenue &&
          "$ " +
          Number(refactor.revenue).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        refactor.tq = refactor.tq && refactor.tq.toFixed(2);
        refactor.rpc =
          refactor.rpc &&
          "$ " +
          Number(refactor.rpc).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        refactor.rpv =
          refactor.rpv &&
          "$ " +
          Number(refactor.rpv).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        refactor.ctr = refactor.ctr && refactor.ctr.toFixed(2) + "%";
        refactor.rpm =
          refactor.rpm &&
          "$ " +
          Number(refactor.rpm).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        refactor.total_searches =
          refactor.total_searches &&
          numberWithSpaces(refactor.total_searches);
        refactor.monetized_searches =
          refactor.monetized_searches &&
          numberWithSpaces(refactor.monetized_searches);
        refactor.clicks =
          refactor.clicks && numberWithSpaces(refactor.clicks);
        refactor.date = moment(refactor.date, "YYYYMMDD").format(
          "YYYY-MM-DD"
        );
        return {
          key: index,
          ...refactor,
        };
      })
      : "";
    return tableDataRefactored;
  };

  const handleSortingClick = useCallback(
    (value, order, multi = false) => {
      setSorting(() => {
        if (!multi) {
          return { [value]: order };
        }
        if (sorting[value] === order) {
          const newOrdering = { ...sorting };
          delete newOrdering[value];
          return newOrdering;
        }
        return { ...sorting, [value]: order };
      });
    },
    [sorting]
  );
  const updateColumns = useCallback(
    (value) => {
      setTableColumns(() => {
        let newTableColumn = [];
        columnTemplate
          .filter((column) => value.checkedColumns[column["value"]])
          .forEach(function ({ text, value, tooltip, render, align }) {
            newTableColumn.push({
              title: (
                <TableTitle
                  text={text}
                  order={sorting[value] ? sorting[value] : false}
                  value={value}
                  align={align}
                  tooltip={tooltip}
                  onSortingClick={handleSortingClick}
                />
              ),
              dataIndex: value,
              align,
              render,
            });
          });
        return newTableColumn;
      });
    },
    [sorting, handleSortingClick]
  );

  const loadZoneData = (cancelToken) => {
    return searchReportsN2sService.getStatsPaged({
      selectedFilters,
      currentPage,
      pageSize,
      sorting,
      cancelToken,
      action: false,
    });
  };

  const [
    {
      data: {
        total: sumOfData,
        table: tableData,
        rows: totalItems,
        missing_dates: missingDates,
      },
      isFetching,
    },
    getZoneData,
  ] = useFetch(loadZoneData);
  const loading = isFetching;

  // useEffect(() => {
  //   if (missingDates && missingDates.length > 0) {
  //     openWarningNotification({
  //       message: "Missing dates:",
  //       description: (
  //         <div className={styles.missingDatesBox}>
  //           {missingDates.map(item => (
  //             <p key={item}>{item}</p>
  //           ))}
  //         </div>
  //       ),
  //       duration: 7,
  //     });
  //   }
  // }, [missingDates]);

  useEffect(() => setCurrentPage(1), []);

  useEffect(() => {
    if (selectedFilters.filters) {
      getZoneData();
    }
  }, [sorting, pageSize, selectedFilters, getZoneData, currentPage]);

  useEffect(() => {
    const selectedColumns = tableColumns.map((item) => item.dataIndex);
    if (
      selectedColumns.includes("date") &&
      selectedColumns.includes("revenue")
    ) {
      setSorting({ date: "descend", revenue: "descend" });
    } else {
      selectedColumns.includes("date")
        ? setSorting({ date: "descend" })
        : setSorting({ revenue: "descend" });
    }
  }, [tableColumns]);

  const handleExport = () => {
    if (selectedFilters.filters) {
      searchReportsN2sService.exportReports({
        selectedFilters,
        currentPage,
        pageSize,
        sorting,
        action: false,
      });
    } else {
      openWarningNotification({
        message: "Please update filters before trying to export table.",
      });
    }
  };
  return (
    <div>
      <div className={styles.titleContainer}>
        <h2 className={styles.pageTitle}>Statistics</h2>
        {!!missingDates?.length && (
          <Button
            className={styles.missingDatesBtn}
            icon={<ExclamationCircleOutlined />}
            onClick={() => setMissingDatesVisible(true)}
          >
            Missing Dates
          </Button>
        )}
      </div>
      <Filters
        campaign_id={location.campaign_id}
        handleExport={handleExport}
        onSubmit={(value) => {
          updateColumns(value);
          setSelectedFilters(value);
        }}
        allColumns={columnsData}
        dateRange={dateRange}
        setDateRange={setDateRange}
        setCurrentPage={setCurrentPage}
      />
      <Table
        className={styles.mainTableContainer}
        style={{ marginTop: "2%" }}
        columns={tableColumns}
        rowKey={({ key }) => key}
        dataSource={refactorTableData()}
        loading={loading}
        scroll={{ x: "max-content", scrollToFirstRowOnChange: true }}
        pagination={false}
        footer={() => {
          return (
            <Pagination
              className="ant-table-pagination ant-table-pagination-right"
              total={totalItems}
              current={currentPage}
              onChange={(value) => setCurrentPage(value)}
              showSizeChanger={true}
              pageSize={pageSize}
              onShowSizeChange={(curr, value) => {
                setPageSize(value);
              }}
              pageSizeOptions={pageSizeOptions}
              showTotal={(total) => {
                if (total)
                  return (
                    <div>
                      Showing {(currentPage - 1) * pageSize + 1} to{" "}
                      {total < currentPage * pageSize
                        ? total
                        : currentPage * pageSize}{" "}
                      of {total} entries.
                    </div>
                  );
              }}
            />
          );
        }}
        summary={() => {
          const sumOfDataRefactored = sumOfDataRefactor();
          const sum =
            sumOfData && sumOfData[0] ? (
              <Table.Summary.Row>
                {tableColumns.map((el, index) => (
                  <Table.Summary.Cell key={index} index={index}>
                    {numberWithSpaces(sumOfDataRefactored[el.dataIndex])}
                  </Table.Summary.Cell>
                ))}
              </Table.Summary.Row>
            ) : null;
          return sum;
        }}
      />
      <MissingDatesModal
        visible={missingDatesVisible}
        setVisible={setMissingDatesVisible}
        missingDates={missingDates}
      />
    </div>
  );
};
